/**
 * Hierarquia da Cadeia de Ajuda — resolve gestor direto a partir de user_organizations.
 */

import type { OrgMember } from '../../../hooks/useOrgMembers';

/** Gestor explícito (reports_to) ou inferido pelo setor (manager/director). */
export function resolveDirectManager(
  member: OrgMember | null | undefined,
  members: OrgMember[],
): OrgMember | null {
  if (!member) return null;

  if (member.reportsToUserId) {
    return members.find((m) => m.id === member.reportsToUserId) ?? null;
  }

  if (member.departmentId) {
    const deptManager = members.find(
      (m) =>
        m.id !== member.id &&
        m.departmentId === member.departmentId &&
        (m.roleType === 'manager' || m.roleType === 'director'),
    );
    if (deptManager) return deptManager;
  }

  return null;
}

/** Liderados diretos — reports_to explícito ou gestor inferido apontando para userId. */
export function getDirectReports(userId: string, members: OrgMember[]): OrgMember[] {
  return members.filter((m) => {
    if (m.id === userId) return false;
    const mgr = resolveDirectManager(m, members);
    return mgr?.id === userId;
  });
}
